import { IAdapterConfig } from '@care-portals/api-interfaces';

export const MockConfig: IAdapterConfig = {
  mock: {
    label: 'Mock',
    functions: {
      echo: {
        middlewareHandler: `mock`,
        version: 2,
        label: 'Echo (Test)',
        params: [{ key: 'testParam', type: 'string', label: 'Test Parameter' }],
        passPayload: true
      }
    }
  }
};
